/**
 * Event constants for cross-service communication
 * 
 * This file defines standard event names that are used for communication
 * between different services in the application.
 */

// Notification-related events
export const NOTIFICATION_EVENTS = {
  // Medication events
  MEDICATION_TAKEN: 'notification:medication_taken',
  
  // Health check events
  HEALTH_CHECK_COMPLETED: 'notification:health_check_completed',
  
  // Sync events
  LOCAL_CHANGE_OCCURRED: 'local-change-occurred'
};

// Export a function to create a custom event with the correct structure
export const createCustomEvent = (eventName, detail = {}) => {
  return new CustomEvent(eventName, {
    bubbles: true,
    cancelable: true,
    detail
  });
}; 